import AvatarImage from 'ui/Element/Image/Avatar'
import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { getDocumentationIcon } from 'lib/util/icon'

const styles = () => ({
  icon: {
    width: '3rem',
    minHeight: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/**
 * Displays the image of an equipment.
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    props for the component
 * @returns {JSX.Element}
 */
const ListItemCellEquipmentImage = (classes, props = {}) => {
  const { image, productType } = props

  const icon = getDocumentationIcon({ name: productType, nodeType: 'product' })

  const attachment = image?.attachment?.value?.name
    ? { ...image.attachment, key: image?.value?.attachmentId || image?.id || undefined, api: { ref: 'equipment' } }
    : { value: { name: '' } }

  return (
    <Grid className={classes.icon}>
      <AvatarImage
        shape={'circle'}
        attachment={attachment}
        fit={'contain'}
        fallbackIcon={{
          ...icon || { name: 'monitor' },
          size: '1.5rem',
          color: 'text.regular',
          background: 'gray.960',
        }}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellEquipmentImage, styles)
